import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import XperienceVideo from '../real-video.vue';
import CurveLine from './curve-dialog.vue';
import { QueueModule } from '@blade-sxp/monitor/store/queue';
import { handleError } from '@blade/common/utils/handle-error';
import { ControlModule } from '@blade-sxp/monitor/store/control';
let default_1 = class default_1 extends Vue {
    timeIntervalType;
    dialogVisible;
    currDevice;
    videoUrl;
    // videoUrl: string = '';
    dataX = [];
    dataSeries = [];
    pollingData;
    minX = 0;
    url = '';
    currIndex = 0;
    rtspUrls = [];
    get deviceLen() {
        const res = this.currDevice.deviceId?.length ?? 0;
        return res;
    }
    mounted() { }
    async getQueueCounting() {
        try {
            const res = await QueueModule.getQueueingCount(this.currDevice.deviceId || '5');
            this.mapData(res);
        }
        catch (e) {
            throw e;
        }
    }
    mapData(data) {
        this.dataX = data.summary.list.map(item => item.date);
        this.dataSeries = data.summary.list.map(item => item.count);
    }
    initPolling() {
        this.pollingData = setInterval(() => this.getQueueCounting(), 1000 * 60 * 5);
    }
    handleClose() {
        console.log('close');
        this.$emit('on-close');
    }
    onVisibleChange(newVal) {
        if (newVal) {
            this.getRtsp();
        }
    }
    handlePre() {
        this.currIndex = this.currIndex - 1 >= 0 ? this.currIndex - 1 : 0;
        this.url = '';
        this.$nextTick(() => this.getRtsp());
    }
    handleN() {
        this.currIndex = this.currIndex + 1 <= this.currDevice.deviceId.length - 1 ? this.currIndex + 1 : this.currIndex;
        this.url = '';
        this.$nextTick(() => this.getRtsp());
    }
    async getRtsp() {
        const currId = this.currDevice.deviceId[this.currIndex];
        QueueModule.updateDeviceId(currId);
        try {
            const res = await ControlModule.getDeviceById(currId);
            this.rtspUrls = new Array(this.currDevice.deviceId.length).fill('');
            this.rtspUrls[this.currIndex] = res.rtspPreviewAddress;
            this.url = res.rtspPreviewAddress;
        }
        catch (e) {
            handleError(e);
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "timeIntervalType", void 0);
__decorate([
    Prop()
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "currDevice", void 0);
__decorate([
    Prop()
], default_1.prototype, "videoUrl", void 0);
__decorate([
    Watch('dialogVisible', { immediate: true })
], default_1.prototype, "onVisibleChange", null);
default_1 = __decorate([
    Component({
        name: 'Dashboard',
        components: { 'xperience-video': XperienceVideo, 'curve-line': CurveLine },
    })
], default_1);
export default default_1;
